module.exports = __webpack_public_path__ + "img/bg.3699c01.png";